import { isDevMode } from '@angular/core';

export class UrlUtils {

	public static isLocalhostOrTest(): boolean {
		const isLocalhost = UrlUtils.isLocalhost() || UrlUtils.isDevMode();
		const isTest = UrlUtils.isTestBareMetal() || UrlUtils.isTestCloud();
		return isLocalhost || isTest;
	}

	public static isLocalhost(): boolean {
		return UrlUtils.testHostname(['localhost']);
	}

	public static isTestBareMetal(): boolean {
		return UrlUtils.testHostname(['test3', 'tstcwpp', 'tszcwpp']);
	}

	public static isTestCloud(): boolean {
		return UrlUtils.testHostname(['testc', 'cwp-tst-cloud-origin']);
	}

	public static isAzrc(): boolean {
		return UrlUtils.testHostname(['azrc']);
	}

	public static isProdCloud(): boolean {
		return UrlUtils.testHostname(['cwp-prod-cloud-origin']);
	}

	public static isInternalHost(): boolean {
		return UrlUtils.testHostname(['webster.bfm.com', 'tst.blackrock.com', 'bwn.blackrock.com', 'dev.blackrock.com']);
	}

	public static isPreview(): boolean {
		return window.location.hostname === 'preview.blackrock.com';
	}
	/**
	 * Checks if the page is in prod dmz (www.blackrock.com) or not
	 */
	public static isProdDmz(): boolean {
		return window.location.hostname === 'www.blackrock.com' || window.location.hostname === 'blackrock.com';
	}

	public static isProduction(): boolean {
		return this.isAzrc() || this.isPreview() || this.isProdDmz() || this.isProdCloud();
	}

	private static testHostname(arrayToTest: string[]): boolean {
		return arrayToTest.some(pattern => window.location.hostname.includes(pattern));
	}

	public static isBetaApp(): boolean {
		return ((window as any).BLK?.appContainerRootPage || '').endsWith('-beta');
	}

	// devMode wrapper for testability
	public static isDevMode(): boolean {
		return isDevMode();
	}

	/**
	 * Returns true if all the provided queryParamsToCheck have not changed, false otherwise.
	 *
	 * @param oldQueryParams
	 * @param queryParams
	 * @param queryParamsToCheck
	 */
	public static isSpecificQueryParamsEqual(oldQueryParams: any, queryParams: any, queryParamsToCheck: string[]): boolean {
		return queryParamsToCheck.every(queryParamToCheck => JSON.stringify(oldQueryParams[queryParamToCheck]) === JSON.stringify(queryParams[queryParamToCheck]));
	}

	/**
	* Converts all duplicate slash to single slash in a url except the first one and returns the formatted URL.
	* Example: "https://testc.blackrock.com/cash/en-us/products///23223//" will be converted to "https://testc.blackrock.com/cash/en-us/products/23223/"
	* @param url
	*/
	public static removeDuplicateSlashes(url: string): string {
		return url?.replace(/([^:]\/)\/+/g, '$1');
	}

	/**
	 * Used to reset the scroll back to the top of the page 
	 */
	public static resetScroll(): void {
		setTimeout(() => { // timeout needed for the page to load
			// covers IE, firefox, safari & chrome
			window.scrollTo(0, 0);
		}, 200);
	}
	/**
	 * Used to decode html content
	 */
	public static htmlDecode(input: string) {
		const doc = new DOMParser().parseFromString(input, 'text/html');
		return doc.documentElement.textContent;
	}
}
